import React from "react";
import { FormGroup } from "@cofano/cck";
import { Language } from "utils";
import { LocationFromQuery } from "view/locations/LocationDetails";

const LocationAddressDetails = ({ address }: { address: LocationFromQuery["address"] }) => {
	return (
		<React.Fragment>
			<FormGroup label={Language("CLIENT_NAME_ONE")} labelPlacement="left-center" overflow="hidden">
				{address?.name1 || "-"}
			</FormGroup>

			<FormGroup label={Language("CLIENT_NAME_TWO")} labelPlacement="left-center" overflow="hidden">
				{address?.name2 || "-"}
			</FormGroup>

			<FormGroup label={Language("CLIENT_STREET")} labelPlacement="left-center" overflow="hidden">
				{address?.street || "-"}
			</FormGroup>

			<FormGroup label={Language("CLIENT_ZIPCODE")} labelPlacement="left-center" overflow="hidden">
				{address?.zipCode || "-"}
			</FormGroup>

			<FormGroup label={Language("PLACE")} labelPlacement="left-center" overflow="hidden">
				{address?.town || "-"}
			</FormGroup>

			<FormGroup label={Language("CLIENT_COUNTRY")} labelPlacement="left-center" overflow="hidden">
				{address?.country || "-"}
			</FormGroup>
		</React.Fragment>
	);
};

export default LocationAddressDetails;
